import { browser } from '$app/environment';
import log from './log';

export interface EppoAssignment {
	variation: string | null;
	action: string | null;
}

interface AssignmentConfig {
	defaultValue?: string;
	subject?: 'anonymousId' | 'commutingZoneId' | 'state';
	[urlAttribute: string]: boolean | string | undefined;
}

export async function getAssignment(
	fetchHandler: typeof fetch,
	experimentName: string,
	config: AssignmentConfig = {}
): Promise<EppoAssignment> {
	const { defaultValue = 'control', subject, ...urlAttributes } = config;
	const base = browser ? window.location.origin : '';

	const searchParams = new URLSearchParams();
	searchParams.set('default', defaultValue);

	if (subject) {
		searchParams.set('subject', subject);
	}

	for (const [key, value] of Object.entries(urlAttributes)) {
		if (value !== null) {
			searchParams.set(key, typeof value === 'string' ? value : value?.toString() ?? '');
		}
	}

	const response = await fetchHandler(
		`${base}/api/eppo/assignment/${experimentName}?${searchParams.toString()}`
	);

	if (!response.ok) {
		log.scope('Eppo').error('Failed to fetch assignment', {
			status: response.status,
			statusText: response.statusText,
			experimentName,
			defaultValue,
			urlAttributes
		});

		return { variation: defaultValue, action: null };
	}

	return response.json();
}
